/**
 * Initiate a delay if required
 * @param  {Boolean}  shouldDelay     Whether or not a delay is in place
 * @param  {Number}   delay           The delay value
 * @return {Promise}                  The promise that will be resolved after the delay
 * @hidden
 */
export const delay = async (shouldDelay = false, delay = 250): Promise<void> => {
  return new Promise((resolve) => {
    if (!shouldDelay) {
      return resolve();
    }
    setTimeout(resolve, delay);
  });
};
